import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import './App.css';

import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import TldDetailPage from './pages/TldDetailPage';
import ProvidersPage from './pages/ProvidersPage';
import AboutPage from './pages/AboutPage';
import GuidePage from './pages/GuidePage';
import KnowledgePage from './pages/KnowledgePage';
import ProviderPage from './pages/ProviderPage';
import ContactPage from './pages/ContactPage';
import LegalPage from './pages/LegalPage';
import ProviderAuthPage from './pages/provider/ProviderAuthPage';
import ProviderDashboardPage from './pages/provider/ProviderDashboardPage';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminProviders from './pages/admin/AdminProviders';
import AdminTlds from './pages/admin/AdminTlds';
import AdminPrices from './pages/admin/AdminPrices';
import AdminPromotions from './pages/admin/AdminPromotions';
import AdminImport from './pages/admin/AdminImport';
import AdminUsers from './pages/admin/AdminUsers';
import AdminInvoices from './pages/admin/AdminInvoices';
import AdminShell from './components/AdminShell';
import HostOnPreviewBadge from './components/HostOnPreviewBadge';
import { isLoggedIn } from './lib/api';
import { isProviderLoggedIn } from './lib/providerApi';

function ProtectedRoute({ children }) {
  if (!isLoggedIn()) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}

function ProviderRoute({ children }) {
  if (!isProviderLoggedIn()) {
    return <Navigate to="/provider/login" replace />;
  }
  return children;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Toaster position="top-right" richColors />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<><Header /><HomePage /><Footer /></>} />
        <Route path="/tld/:tld" element={<><Header /><TldDetailPage /><Footer /></>} />
        <Route path="/anbieter" element={<><Header /><ProvidersPage /><Footer /></>} />
        <Route path="/ueber-uns" element={<><Header /><AboutPage /><Footer /></>} />
        <Route path="/ratgeber" element={<><Header /><GuidePage /><Footer /></>} />
        <Route path="/domain-technik" element={<><Header /><KnowledgePage /><Footer /></>} />
        <Route path="/fuer-provider" element={<><Header /><ProviderPage /><Footer /></>} />
        <Route path="/kontakt" element={<><Header /><ContactPage /><Footer /></>} />
        <Route path="/impressum" element={<><Header /><LegalPage /><Footer /></>} />

        {/* Provider Portal */}
        <Route path="/provider/login" element={<ProviderAuthPage />} />
        <Route path="/provider/register" element={<ProviderAuthPage />} />
        <Route path="/provider/dashboard" element={<ProviderRoute><ProviderDashboardPage /></ProviderRoute>} />
        
        {/* Admin Login (public) */}
        <Route path="/admin/login" element={<AdminLogin />} />
        
        {/* Protected Admin Routes */}
        <Route path="/admin" element={<ProtectedRoute><AdminShell /></ProtectedRoute>}>
          <Route index element={<AdminDashboard />} />
          <Route path="providers" element={<AdminProviders />} />
          <Route path="tlds" element={<AdminTlds />} />
          <Route path="prices" element={<AdminPrices />} />
          <Route path="promotions" element={<AdminPromotions />} />
          <Route path="import" element={<AdminImport />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="invoices" element={<AdminInvoices />} />
        </Route>
      </Routes>
      <HostOnPreviewBadge />
    </BrowserRouter>
  );
}
